import styles from './ImageViewer.module.scss'

export interface ImageViewerProps {
    WidgetTop?: React.FC;
    src?: string;
    style?:  React.CSSProperties | undefined
  
  }
  
export default function ImageViewer({WidgetTop, src, style}:ImageViewerProps) {

  return (
    <div style={style} className={styles['image-container-global']}>
   { WidgetTop &&
              <div className={styles['btn-container']}>     <div className={styles['btn-container__btn-container-sticky']}><WidgetTop/></div></div>
            }

    <div className={styles['image-container']}>

        {src ?
        <img  className={styles["image-container__image"]} src={src} alt="PlanBT" /> : 

        <div className={styles["image-container__no-image"]}>

            <p className={styles["image-container__no-image__text"]}>Aucune image</p>
        </div>
        }
    </div>
    </div>
  )
}
